declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

const GA_MEASUREMENT_ID = 'G-ZPERYNKR4N';

// Only loads in production builds (import.meta.env.PROD, i.e. `vite build`);
// never during local `vite dev`, so dev/test traffic doesn't pollute analytics.
export function initAnalytics(): void {
  if (!import.meta.env.PROD) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  const gtag = (...args: unknown[]) => window.dataLayer.push(args);
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
}
